/* eslint-disable */
var baseApiUrl = ''
var appBaseUrl = ''
if (process.env.NODE_ENV === 'production') {
  // baseApiUrl = 'https://discussion-tool-demo-api.geodemosolutions.com/public/'
  // appBaseUrl = 'https://discussion-tool-demo.geodemosolutions.com/#/'
  baseApiUrl = 'https://ccra-tool-demo-api.geodemosolutions.com/public/'
  appBaseUrl = 'https://ccra-tool-demo.geodemosolutions.com/#/'
 }
else {
  baseApiUrl = 'http://localhost/discussion-tool-api/public/'
  // baseApiUrl = 'http://localhost/nel-fwp-discussion-tool-api/public/'
  appBaseUrl = 'http://localhost:7800/#/'
}

export {
  baseApiUrl,
  appBaseUrl
}
